import { render, staticRenderFns } from "./modalGrupos.vue?vue&type=template&id=3bd6f1e2&scoped=true&"
import script from "./modalGrupos.vue?vue&type=script&lang=js&"
export * from "./modalGrupos.vue?vue&type=script&lang=js&"
import style0 from "./modalGrupos.vue?vue&type=style&index=0&id=3bd6f1e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd6f1e2",
  null
  
)

export default component.exports